/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LeerlingenInputs */

const nl_nav_leerlingen = /** @type {(inputs: Nav_LeerlingenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerlingen`)
};

/**

* @param {Nav_LeerlingenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_leerlingen = /** @type {((inputs?: Nav_LeerlingenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LeerlingenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_leerlingen(inputs)
});
export { nav_leerlingen as "nav.leerlingen" }